export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/it.a28b8888.svg","height":2,"width":3,"blurWidth":0,"blurHeight":0};